/* ==========================================================================
   FIND A DOCTOR — scroll reveal for the numbers band, plus the count-up.
   Without JS (or with reduced motion) the band is simply shown with its
   final numbers, which the template already renders.
   ========================================================================== */
(function () {
  var page = document.querySelector('.fad');
  if (!page) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // "Find a clinic" -> the map. Something else on the site cancels plain
  // #anchor clicks, so scroll here; the theme's scroll-padding clears the header.
  var cta = page.querySelector('.fad-hero__cta');
  var map = document.getElementById('fad-map');
  if (cta && map) {
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      map.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  var items = page.querySelectorAll('.fad-reveal');
  if (reduce || !('IntersectionObserver' in window)) return;

  var lang = document.documentElement.lang || undefined;
  var format;
  try { format = new Intl.NumberFormat(lang); } catch (e) { format = new Intl.NumberFormat(); }

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (!target) return;
    var suffix = el.getAttribute('data-suffix') || '';
    // Keep any trailing markup (the "years" unit) and only animate the number.
    var unit = el.querySelector('.fad-stat__unit');
    var textNode = document.createTextNode('');
    el.textContent = '';
    el.appendChild(textNode);
    if (unit) el.appendChild(unit);

    var duration = 1800;
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 4);
      textNode.nodeValue = format.format(Math.round(target * eased)) + (t === 1 ? suffix : '');
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  page.classList.add('is-ready');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      var value = entry.target.querySelector('.fad-stat__value[data-count]');
      if (value) countUp(value);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.4 });

  items.forEach(function (el) { io.observe(el); });
})();
